import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ReverseYourWrinkles = lazyWithPreload(
  () => import('./ReverseYourWrinkles'),
)

export const ReverseYourWrinkles3 = lazyWithPreload(
  () => import('./ReverseYourWrinkles3'),
)
